import React from 'react';

import AvailabilityForm from './AvailabilityForm';
import {useCreateProviderAvailabilityMutation} from '../../redux/services/providerAvailabilityApi';

const handleSubmit = ({post, afterSubmit}) => async formData => {
  const body = formData;
  const response = await post(body);
  if (response?.error) {
    console.error(new Error(response.error?.data?.errors?.[0]));
    return Promise.reject(response.error?.data?.errors?.[0]);
  }
  if (afterSubmit) afterSubmit(response);
  return Promise.resolve(response);
};

const NewAvailabilityForm = ({afterSubmit} = {}) => {
  const [post] = useCreateProviderAvailabilityMutation();
  return (
    <AvailabilityForm 
      onSubmit={handleSubmit({post, afterSubmit})}
      afterSubmit={afterSubmit}
    />
  );
};

export default NewAvailabilityForm;